import { createTheme } from '@mui/material';
import { TypographyOptions } from '@mui/material/styles/createTypography';

declare module "@mui/system/createTheme/createBreakpoints" {
    interface BreakpointOverrides {
        xsm: true
        xxl: true
    }
}
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        subtitle14: true
        subtitle16: true
        descGray: true,
    }
}

interface ExtendedTypographyOptions extends TypographyOptions {
    subtitle14: React.CSSProperties;
    descGray: React.CSSProperties,
  }

let defaultLightTheme = createTheme({
    palette: {
        primary: {
            main: '#081120'
        }
    },
    breakpoints: {
      keys: ['xs', 'xsm', 'sm', 'md', 'lg', 'xl', 'xxl'],
    },
    spacing: 1,
    typography: {
        fontFamily: 'Kind',
        fontSize: 16,
        h1: {
            color: '#fff',
            fontSize: '64px',
            fontFamily: 'Kind',
        },
        h2: {
            color: '#fff',
            fontSize: '50px',
            fontFamily: 'Kind',
        },
        h3: {
            color: '#fff',
            fontSize: '20px',
            fontFamily: 'Kind',
        },
        subtitle1: {
            color: '#fff',
            fontFamily: 'Kind',
            fontSize: '16px'
        },
        subtitle2: {
            color: '#fff',
            fontFamily: 'Kind',
            fontSize: '14px'
        },
        body1: {
            color: '#fff',
            fontSize:'16px',
            fontFamily: 'Kind',
        },
        body2: {
            color: '#fff',
            fontSize:'14px',
            fontFamily: 'Kind',
        },
        descGray: {
            color: '#8F9DB3',
            fontSize:'14px',
            fontFamily: 'Kind',
        }
    }as ExtendedTypographyOptions,
    components: {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    background: 'rgb(67, 84, 112)'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#F2F2F2'
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    border: '1px solid #435470',
                    backgroundColor: '#2B374A',
                    '.MuiInputBase-root': {
                        color: '#fff'
                    },
                    '.Mui-disabled': {
                        'text-fill-color': 'rgba(255, 255, 255, 1) !important',
                        '-webkit-text-fill-color': 'rgba(255, 255, 255, 1) !important'
                    }
                },
            }
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    '.MuiDrawer-paper': {
                        marginTop: '80px',
                        marginBottom: '10px',
                        borderRadius: '16px',
                        height: 'calc(100% - 90px)'
                    }
                }
                
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    padding: '0'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    padding: '30px',
                    borderRadius: '16px',
                    background: '#1D2738'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '65px',
                    textTransform: 'none',
                    fontSize: '16px',
                    color: '#ffffff',
                    padding: '15px 30px',
                    height: "54px",
                    fontFamily: 'Kind',
                    '&:hover': {
                        backgroundColor: '#4C67EF'
                    },
                    '&.Mui-disabled': {
                        color: '#7F7F7F',
                        background: '#373737',
                    }
                },
                contained: {
                    background: '#fff',
                    color: '#4C67EF',
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: '#4C67EF',
                        color: '#fff',
                        boxShadow: 'none',
                    },
                },
                outlined: {
                    border: '1px solid #fff',
                    color: '#FFFFFF',
                    background: 'transparent',
                    '&:hover': {
                        border: '1px solid #fff',
                        color: '#ffffff',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    }
                },
                sizeSmall: {
                    height: '28px'
                }
            }
        },
        MuiPagination: {
            styleOverrides:{
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: 'Kind',
                    backgroundColor: '#081120',
                    color: '#fff',
                },
                a: {
                    textDecoration: 'none',
                    color: 'inherit',
                },
                ".Toastify__toast": {
                    background: '#2B374A',
                    borderRadius: '10px',
                },
                ".Toastify__toast-body": {
                    color: "#fff",
                    background: '#2B374A',
                },
                ".Toastify__close-button": {
                    color: '#fff'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                arrow: {
                    color: '#fff',
                    '&:before': {
                        border: '1px solid #435470',
                    }
                },
                tooltip: {
                    background: '#fff',
                    borderRadius: '5px',
                    border: '1px solid #435470',
                    padding: '12px 17px',
                },
            }
        }
    }
});

defaultLightTheme.typography.h1 = {
    [defaultLightTheme.breakpoints.down('md')]: {
        fontSize: '36px'
    }
}

// defaultLightTheme.typography.h3 = {
//     [defaultLightTheme.breakpoints.down('md')]: {
//         fontSize: '14px'
//     }
// }
// defaultLightTheme.typography.subtitle1 = {
//     [defaultLightTheme.breakpoints.down('md')]: {
//         fontSize: '12px'
//     }
// }
// defaultLightTheme.typography.subtitle2 = {
//     [defaultLightTheme.breakpoints.down('md')]: {
//         fontSize: '12px'
//     }
// }

// defaultLightTheme.typography.body1 = {
//     [defaultLightTheme.breakpoints.down('md')]: {
//         fontSize: '12px'
//     }
// }

// defaultLightTheme.typography.body2 = {
//     [defaultLightTheme.breakpoints.down('md')]: {
//         fontSize: '12px'
//     }
// }


export default defaultLightTheme;